import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRocket } from '@fortawesome/free-solid-svg-icons';

const WaitlistForm = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [referralLink, setReferralLink] = useState('');
  const [referrerEmail, setReferrerEmail] = useState('');
  const [message, setMessage] = useState('');

  const location = useLocation();
  const API_URL = 'https://nova-marketing-65096d586382.herokuapp.com';

  useEffect(() => {
    // Extract referrer from the query parameter
    const searchParams = new URLSearchParams(location.search);
    const ref = searchParams.get('ref');
    if (ref) {
      setReferrerEmail(ref);
    }
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Include the referrer email in the request if it exists
      const response = await fetch(`${API_URL}/api/waitlist`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ firstName, lastName, email }),
      });

      const result = await response.json();

      if (response.status === 409) {
        // If email is already on the waitlist
        setMessage('You are already on the waitlist!');
      } else if (response.ok) {
        // If the user is successfully added
        setStatus("Congratulations! You've joined the waitlist.");
        setSubmitted(true);
        const uniqueReferralLink = `${window.location.origin}/refer?ref=${email}`;
        setReferralLink(uniqueReferralLink); // Generate referral link for the user
        setMessage('');
      } else {
        setMessage('Failed to join the waitlist. Please try again.');
      }
    } catch (error) {
      setMessage('Error submitting the form.');
      console.error("Error:", error);
    }
  };

  return (
    <div className="container">
      <header className="header-container">
        <FontAwesomeIcon
          icon={faRocket}
          className="rocket-icon"
          size="3x"
          style={{ color: '#9146ff', marginRight: '10px' }}
        />
        <h1>Unlock Your Best Self with Nova</h1>
        {!submitted && <p>Join the waitlist to get early access to our self-improvement tool.</p>}
      </header>

      <div className="form-container">
        {!submitted && (
          <form onSubmit={handleSubmit}>
            <label>First Name</label>
            <input
              type="text"
              placeholder="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
            <label>Last Name</label>
            <input
              type="text"
              placeholder="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
            <label>Email</label>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit">Join the Waitlist</button>
          </form>
        )}

        {submitted && (
          <div className="body-container">
            <p className="status">{status}</p>
            {referralLink && (
              <p>
                Refer your friends to get ahead of the line and access exclusive functionality! <br /> 
                <a href={referralLink}>{referralLink}</a>
              </p>
            )}
          </div>
        )}
        {message && <p className ="status">{message}</p>}
      </div>
    </div>
  );
};

export default WaitlistForm;
